'use strict'

class ModalController {
	static SELECTOR_CLASS_TRIGGER = '.trigger__modal'
	static SELECTOR_CLASS_CLOSE = '.close__modal'
	static SELECTOR_CLASS_LOGIN_CONTENT = '.modal__container--login'
	static SELECTOR_CLASS_HIDDEN_LOGIN = '.hidden__loginform'
	static CLASS_NAME_MODAL_OPEN = 'modal__open'
	static CLASS_NAME_MODAL_CONTAINER = 'modal__container'
	static CLASS_NAME_MODAL_INNER = 'modal__container--inner'
	static CLASS_NAME_MODAL_LOGIN = 'modal__container--login'
	static CLASS_NAME_MODAL_HTML = 'modal__container--html'
	static CLASS_NAME_MODAL_SCROLLABLE = 'modal__container--scrollable'
	static ATTR_DATA_EMBED = 'embed'
	static ATTR_DATA_TYPE = 'type'
	static PROP_TYPE_IMAGE = 'image'
	static PROP_TYPE_YOUTUBE = 'youtube'
	static PROP_TYPE_LOGIN = 'login'
	static PROP_TYPE_HTML = 'html'
	static TEXT_LOGIN_HEADING = 'Site Login '

	init() {
		document.addEventListener( 'click', ( e ) => {
			if ( e.target.closest( ModalController.SELECTOR_CLASS_TRIGGER ) ) {
				e.preventDefault()
				this.handleTriggerClick( e.target.closest( ModalController.SELECTOR_CLASS_TRIGGER ) )
			} else if ( e.target.closest( ModalController.SELECTOR_CLASS_CLOSE ) ) {
				e.preventDefault()
				this.handleCloseClick()
			}
		} )

		document.addEventListener( 'click', ( e ) => {
			if ( e.target.closest( ModalController.SELECTOR_CLASS_LOGIN_CONTENT ) ) {
				e.stopPropagation()
			}
		} )
	}

	handleTriggerClick( trigger ) {
		const body = document.body
		body.classList.add( ModalController.CLASS_NAME_MODAL_OPEN )

		const embedData = trigger.dataset[ ModalController.ATTR_DATA_EMBED ]
		const type = trigger.dataset[ ModalController.ATTR_DATA_TYPE ]
		let modalHTML = ''

		switch ( type ) {
			case ModalController.PROP_TYPE_IMAGE: {
				modalHTML = this.createImageModal( embedData )
				break
			}
			case ModalController.PROP_TYPE_YOUTUBE: {
				modalHTML = this.createYoutubeModal( embedData )
				break
			}
			case ModalController.PROP_TYPE_LOGIN: {
				modalHTML = this.createLoginModal()
				break
			}
			case ModalController.PROP_TYPE_HTML: {
				modalHTML = this.createHTMLModal( embedData )
				break
			}
			default: {
				break
			}
		}

		const modalContainer = document.createElement( 'div' )
		modalContainer.innerHTML = modalHTML
		body.appendChild( modalContainer.firstChild )
	}

	createImageModal( imageURL ) {
		return '<div class="' + ModalController.CLASS_NAME_MODAL_CONTAINER + '">' +
			'<div class="' + ModalController.CLASS_NAME_MODAL_INNER + '" style="background-image: url(' + imageURL + ');">' +
			'<a class="' + ModalController.SELECTOR_CLASS_CLOSE.substring( 1 ) + '" href="#"><i class="fal fa-times"></i></a>' +
			'</div></div>'
	}

	createYoutubeModal( videoID ) {
		return '<div class="' + ModalController.CLASS_NAME_MODAL_CONTAINER + '">' +
			'<div class="' + ModalController.CLASS_NAME_MODAL_INNER + '">' +
			'<iframe width="100%" height="315" src="https://www.youtube.com/embed/' + videoID + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>' +
			'<a class="' + ModalController.SELECTOR_CLASS_CLOSE.substring( 1 ) + '" href="#"><i class="fal fa-times"></i></a>' +
			'</div></div>'
	}

	createLoginModal() {
		const hiddenLoginForm = document.querySelector( ModalController.SELECTOR_CLASS_HIDDEN_LOGIN )
		const loginFormHTML = hiddenLoginForm ? hiddenLoginForm.innerHTML : ''
		return '<div class="' + ModalController.CLASS_NAME_MODAL_CONTAINER + '">' +
			'<div class="' + ModalController.CLASS_NAME_MODAL_INNER + '">' +
			'<div class="' + ModalController.CLASS_NAME_MODAL_LOGIN + '">' +
			'<h2>' + ModalController.TEXT_LOGIN_HEADING + '</h2>' +
			loginFormHTML +
			'</div>' +
			'<a class="' + ModalController.SELECTOR_CLASS_CLOSE.substring( 1 ) + '" href="#"><i class="fal fa-times"></i></a>' +
			'</div></div>'
	}

	createHTMLModal( contentID ) {
		const contentElement = document.getElementById( contentID )
		const textContents = contentElement ? contentElement.innerHTML : ''
		return '<div class="' + ModalController.CLASS_NAME_MODAL_CONTAINER + '">' +
			'<div class="' + ModalController.CLASS_NAME_MODAL_INNER + '">' +
			'<div class="' + ModalController.CLASS_NAME_MODAL_HTML + '">' +
			'<div class="' + ModalController.CLASS_NAME_MODAL_SCROLLABLE + '">' +
			textContents +
			'</div></div>' +
			'<a class="' + ModalController.SELECTOR_CLASS_CLOSE.substring( 1 ) + '" href="#"><i class="fal fa-times"></i></a>' +
			'</div></div>'
	}

	handleCloseClick() {
		const modalContainer = document.querySelector( '.' + ModalController.CLASS_NAME_MODAL_CONTAINER )
		if ( modalContainer ) {
			modalContainer.remove()
		}
		document.body.classList.remove( ModalController.CLASS_NAME_MODAL_OPEN )
	}
}

export default function init() {
	new ModalController().init()
}
